import { ContentColumn } from './content-column';
import { ScreenShell } from './screen-shell';

/**
 * 라우트 loader (가드 await + lazy 청크 다운로드) 가 완료되기 전 최초 진입 시 보이는 폴백.
 * RR 의 `HydrateFallback` 으로 등록. 모바일은 RN BootSplash 가 가려서 사실상 데스크톱용.
 */
export function RouteFallback() {
  return (
    <ScreenShell>
      <ContentColumn as="main" className="m-auto flex items-center justify-center">
        <div
          className="h-6 w-6 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent"
          aria-label="Loading"
          role="status"
        />
      </ContentColumn>
    </ScreenShell>
  );
}
